<template>
  <el-tooltip placement="bottom-end" :visible-arrow="false" popper-class="tip-wrapper" :offset="395">
    <div slot="content" class="box">
      <div class="title">议价公示</div>
      <div class="number">出价人数: {{number}}</div>
      <div class="list">
        <div class="item" v-for="(item, index) in detailsData" :key="index">
          <div class="left">
            <div class="card">ID:{{ item.buyer_user_id }}</div>
            <div class="time">{{item.update_time}}</div>
          </div>
          <div class="right">{{item.buyer_price}}</div>
        </div>
      </div>
    </div>
    <span v-html="contentText" style="cursor: pointer;"></span>
  </el-tooltip>
</template>

<script>
export default {
  name: 'bargainPublicity',
  props: {
    contentText: {
      type: [String, Number],
      default: '',
    },
    number: {
      type: [String, Number],
      default: '',
    },
    detailsData: {
      type: Array,
      default: () => {
        return []
      },
    }
  },
}
</script>

<style lang="less">
.tip-wrapper{
  background: rgba(0,0,0,0.7) !important;
  .box{
    box-sizing: border-box;
    width: 395px;
    max-height: 330px;
    padding: 10px 20px;
    overflow-y: scroll;
    &::-webkit-scrollbar {
      width: 0px; /* 滚动条宽度 */
    }

    &::-webkit-scrollbar-track {
      background-color: #f1f1f1; /* 滚动条背景色 */
    }

    &::-webkit-scrollbar-thumb {
      background-color: #888; /* 滚动条滑块颜色 */
    }
  }
  .title{
    text-align: center;
    color: #FFF;
    font-family: PingFang SC;
    font-size: 16px;
    font-style: normal;
    font-weight: 600;
    line-height: normal;
  }
  .number{
    color: #FFF;
    font-family: PingFang SC;
    font-size: 14px;
    font-style: normal;
    font-weight: 500;
    line-height: normal;
    margin-bottom: 10px;
  }
  .list{
    .item{
      display: flex;
      justify-content: space-between;
      align-items: center;
      color: #FFF;
      font-family: PingFang SC;
      font-size: 12px;
      font-style: normal;
      font-weight: 400;
      line-height: normal;
      padding: 8px 0;
      border-top: 1px #FFFFFF33 solid;
      // border-bottom: 1px #fff solid;
      .left{
        .card{}
        .time{}
      }
      .right{}
    }
  }
}
</style>